import { StoriesPopupLazy } from './storiesPopupLazy';

const props = [
    'sourceRoute'
];

export const StoryPopupDirective = reactDirective => reactDirective( StoriesPopupLazy, props);
StoryPopupDirective.$inject = ['reactDirective'];

angular.module('WB.App').directive('storyPopup', StoryPopupDirective);
